/* Scent Finder quiz (sections/scent-finder.liquid). Moved out of the section on 2026-10-13 so its
   ~40 KB no longer runs while the page is being parsed: loaded with defer, cached between pages.
   Re-initialises when the theme editor reloads the section. */
(function () {
function sfInit() {
  var root = document.querySelector('[data-scent-finder]');
  if (!root) return;
  var LANG = root.getAttribute('data-lang') === 'fr' ? 'fr' : 'en';
  function T(o) { return (o && (o[LANG] != null ? o[LANG] : o.en)) || ''; }
  function localizeUrl(path) {
    if (/^https?:/i.test(path)) return path;
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    return rootPath.replace(/\/$/, '') + path;
  }

  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>';

  var ICONS = {
    flame: '<path d="M12 3c2.5 3 4.2 5.2 4.2 8a4.2 4.2 0 0 1-8.4 0c0-1.4.6-2.6 1.5-3.6.2 1.5 1.6 1.7 1.6.2 0-1.4-1-2.4 1.1-4.8z"/>',
    heart: '<path d="M12 20s-6.5-4.2-6.5-9A3.5 3.5 0 0 1 12 8a3.5 3.5 0 0 1 6.5 3c0 4.8-6.5 9-6.5 9z"/>',
    drop:  '<path d="M12 3.5c2.8 3.6 4.6 6 4.6 8.6a4.6 4.6 0 0 1-9.2 0c0-2.6 1.8-5 4.6-8.6z"/>',
    sun:   '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4 12H2M22 12h-2M5 5l1.5 1.5M17.5 17.5L19 19M19 5l-1.5 1.5M6.5 17.5L5 19"/>',
    moon:  '<path d="M20 13.5A8 8 0 1 1 10.5 4a6.3 6.3 0 0 0 9.5 9.5z"/>',
    leaf:  '<path d="M5 19c0-7.5 5.5-12.5 14-13.5C18 13 12.5 19 5 19z"/><path d="M5 19c3.5-3.5 5.5-5.5 8.5-7.5"/>',
    waves: '<path d="M3 9c2.5-2.5 5.5 2.5 9 0s6.5-2.5 9 0"/><path d="M3 15c2.5-2.5 5.5 2.5 9 0s6.5-2.5 9 0"/>',
    spark: '<path d="M12 3.5l1.9 5.6 5.6 1.9-5.6 1.9L12 18.5l-1.9-5.6L4.5 11l5.6-1.9z"/>',
    duo:   '<circle cx="9" cy="12" r="4.5"/><circle cx="15" cy="12" r="4.5"/>'
  };
  var GRADS = {
    red: 'linear-gradient(135deg,#ff8a8a,#ff2b6b)', pink: 'linear-gradient(135deg,#ffa6c9,#ff4f97)',
    cyan: 'linear-gradient(135deg,#7fe0ff,#3aa0ff)', amber: 'linear-gradient(135deg,#ffce8a,#ff9a3d)',
    indigo: 'linear-gradient(135deg,#9b8cff,#5b4bd6)', mint: 'linear-gradient(135deg,#a8efce,#42c98c)',
    blue: 'linear-gradient(135deg,#a9c8ff,#5b86ff)', magenta: 'linear-gradient(135deg,#ff7ab0,#e0186b)',
    purple: 'linear-gradient(135deg,#cca9ff,#8b5cf6)', caramel: 'linear-gradient(135deg,#f0c489,#c4894a)',
    multi: 'linear-gradient(135deg,#ffb27a,#7a9bff)'
  };
  function mediaHtml(o, stepId) {
    var img = (SF_OVERRIDES && SF_OVERRIDES[stepId + '_' + o.v]) || o.img;
    if (img) return '<span class="sf-opt__media"><img class="sf-opt__img" src="' + img + '" alt="" loading="eager" decoding="async"></span>';
    var svg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">' + (ICONS[o.icon] || ICONS.spark) + '</svg>';
    return '<span class="sf-opt__media sf-opt__tile" style="background:' + (GRADS[o.tint] || GRADS.pink) + '" aria-hidden="true">' + svg + '</span>';
  }

  var IMG = 'https://cdn.shopify.com/s/files/1/0551/4874/0681/files/';
  // Merchant image overrides come from the section (theme editor), set inline as window.SF_OVERRIDES.
  var SF_OVERRIDES = window.SF_OVERRIDES || {};

  var UI = {
    next:     { en: 'Next', fr: 'Suivant' },
    see:      { en: 'See my result', fr: 'Voir mon résultat' },
    qa:       { en: 'Question ', fr: 'Question ' },
    qb:       { en: ' of ', fr: ' sur ' },
    retake:   { en: 'Retake the quiz', fr: 'Refaire le quiz' },
    tag:      { en: 'Your scent profile', fr: 'Votre profil olfactif' },
    notesCap: { en: 'Notes you’ll likely love', fr: 'Des notes que vous allez adorer' },
    browse:   { en: 'Browse matching scents', fr: 'Découvrir des parfums assortis' },
    ctaLabel: { en: 'Start my subscription', fr: 'Commencer mon abonnement' },
    max:      { en: 'Max ', fr: 'Maximum ' },
    modalTitle: { en: 'Matching scents', fr: 'Parfums assortis' },
    viewAll:  { en: 'View all results', fr: 'Voir tous les résultats' },
    loading:  { en: 'Finding your matches…', fr: 'Recherche de vos correspondances…' },
    empty:    { en: 'No matching products found.', fr: 'Aucun produit correspondant trouvé.' },
    hideMatches: { en: 'Hide', fr: 'Masquer' },
    calTitle: { en: 'Your suggested scent calendar', fr: 'Votre calendrier olfactif suggéré' },
    calSub:   { en: 'Your personalized 12-month calendar, matched to your quiz. Tap + to add a scent to your next open month, or add all 12 at once.', fr: 'Votre calendrier personnalisé de 12 mois, selon votre quiz. Touchez + pour ajouter un parfum à votre prochain mois libre, ou ajoutez les 12 d’un coup.' },
    addAria:  { en: 'Add to my calendar', fr: 'Ajouter à mon calendrier' },
    addedAria: { en: 'Added', fr: 'Ajouté' },
    exclusiveTag: { en: '+C$5.00', fr: '+5,00 $' },
    scentsSelected: { en: 'scents selected', fr: 'parfums sélectionnés' },
    surchargeNote: { en: 'in premium surcharges', fr: 'de surcharge premium' },
    addAllLabel: { en: 'Add all 12 to my calendar', fr: 'Ajouter les 12 à mon calendrier' },
    addAllHint: { en: 'Scents fill your open months in order. You can rearrange anytime.', fr: 'Les parfums remplissent vos mois libres dans l’ordre. Vous pouvez les réorganiser en tout temps.' },
    addAllDone: { en: 'All 12 added', fr: 'Les 12 ont été ajoutés' },
    mpTextOne: { en: 'Add to your calendar', fr: 'Ajouter à votre calendrier' },
    mpLabel: { en: 'Choose a month', fr: 'Choisir un mois' },
    mpConfirm: { en: 'Add to calendar', fr: 'Ajouter au calendrier' },
    mpCancel: { en: 'Cancel', fr: 'Annuler' },
    mpSkip: { en: 'Skip this one', fr: 'Passer' },
    mpAdding: { en: 'Adding…', fr: 'Ajout…' },
    mpEmpty: { en: 'No open months left in your calendar. Manage it in My Account.', fr: 'Aucun mois libre dans votre calendrier. Gérez-le dans Mon compte.' },
    mpSurcharge: { en: 'Exclusive scent — an extra +C$5.00 applies that month.', fr: 'Parfum exclusif — un supplément de +5,00 $ s’applique ce mois-là.' },
    mpToastAdded: { en: 'Added to your calendar.', fr: 'Ajouté à votre calendrier.' },
    mpToastError: { en: 'Could not add it — please try again.', fr: 'Impossible de l’ajouter — veuillez réessayer.' }
  };
  var MONTHS_SHORT = {
    en: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    fr: ['janv','févr','mars','avr','mai','juin','juil','août','sept','oct','nov','déc']
  };

  var STEPS = [
    { id: 'gender', type: 'single',
      title: { en: 'Who are we finding a scent for?', fr: 'Pour qui cherchons-nous un parfum ?' },
      sub: { en: '', fr: '' },
      options: [
        { v: 'feminine',  img: IMG + 'Feminine.jpg?v=1707276368',   label: { en: 'For her', fr: 'Pour elle' } },
        { v: 'masculine', img: IMG + 'Masculine.jpg?v=1707276369',  label: { en: 'For him', fr: 'Pour lui' } },
        { v: 'unisex',    icon: 'duo', tint: 'purple',              label: { en: 'Unisex', fr: 'Unisexe' } },
        { v: 'any',       img: IMG + 'ALL_BOTTLES.jpg?v=1687983101', label: { en: 'Surprise me', fr: 'Surprenez-moi' } } ] },
    { id: 'families', type: 'multi', max: 3,
      title: { en: 'Which scent families pull you in?', fr: 'Quelles familles olfactives vous attirent ?' },
      sub: { en: 'Pick up to 3 — these guide your match the most.', fr: 'Choisissez-en jusqu’à 3 — elles orientent le plus votre résultat.' },
      options: [
        { v: 'fresh',    img: IMG + 'citrus-notes.jpg?v=1702603468',  label: { en: 'Fresh & Citrus', fr: 'Frais et agrumes' } },
        { v: 'floral',   img: IMG + 'Floral.png?v=1697892018',        label: { en: 'Floral', fr: 'Floral' } },
        { v: 'woody',    img: IMG + 'woody-notes.jpg?v=1702611315',   label: { en: 'Warm & Woody', fr: 'Chaud et boisé' } },
        { v: 'gourmand', icon: 'drop', tint: 'caramel',              label: { en: 'Sweet & Gourmand', fr: 'Sucré et gourmand' } },
        { v: 'oriental', img: IMG + 'spicy-notes.jpg?v=1702603563',   label: { en: 'Spicy & Oriental', fr: 'Épicé et oriental' } },
        { v: 'fruity',   img: IMG + 'mango.jpg?v=1702603518',         label: { en: 'Fruity', fr: 'Fruité' } },
        { v: 'aquatic',  img: IMG + 'aquatic-accord.jpg?v=1702603444', label: { en: 'Clean & Aquatic', fr: 'Propre et aquatique' } },
        { v: 'green',    img: IMG + 'green-tea.jpg?v=1702603493',      label: { en: 'Green & Aromatic', fr: 'Vert et aromatique' } } ] },
    { id: 'vibe', type: 'single',
      title: { en: 'What vibe are you after?', fr: 'Quelle ambiance recherchez-vous ?' },
      options: [
        { v: 'bold',       icon: 'flame', tint: 'red',    label: { en: 'Bold & magnetic', fr: 'Audacieux et magnétique' } },
        { v: 'soft',       icon: 'heart', tint: 'pink',   label: { en: 'Soft & intimate', fr: 'Doux et intime' } },
        { v: 'fresh',      icon: 'drop',  tint: 'cyan',   label: { en: 'Fresh & effortless', fr: 'Frais et sans effort' } },
        { v: 'warm',       icon: 'sun',   tint: 'amber',  label: { en: 'Warm & cozy', fr: 'Chaleureux et réconfortant' } },
        { v: 'mysterious', icon: 'moon',  tint: 'indigo', label: { en: 'Mysterious & deep', fr: 'Mystérieux et profond' } } ] },
    { id: 'occasion', type: 'single',
      title: { en: 'When will you wear it most?', fr: 'Quand le porterez-vous le plus ?' },
      options: [
        { v: 'everyday', img: IMG + 'casual.png?v=1697892018', label: { en: 'Everyday signature', fr: 'Tous les jours' } },
        { v: 'date',     img: IMG + 'Date.png?v=1697892018',   label: { en: 'Date night', fr: 'Soirée en amoureux' } },
        { v: 'work',     img: IMG + 'office.png?v=1697892018',  label: { en: 'Office & work', fr: 'Au bureau' } },
        { v: 'special',  img: IMG + 'party.png?v=1697892018',   label: { en: 'Special occasions', fr: 'Grandes occasions' } },
        { v: 'outdoors', img: IMG + 'sporty.png?v=1697892018',  label: { en: 'Outdoors & travel', fr: 'Plein air et voyage' } } ] },
    { id: 'intensity', type: 'single',
      title: { en: 'How much presence do you like?', fr: 'Quelle intensité préférez-vous ?' },
      options: [
        { v: 'subtle',   icon: 'leaf',  tint: 'mint',    label: { en: 'Subtle skin scent', fr: 'Subtil, près de la peau' } },
        { v: 'balanced', icon: 'waves', tint: 'blue',    label: { en: 'Balanced & noticeable', fr: 'Équilibré et perceptible' } },
        { v: 'bold',     icon: 'spark', tint: 'magenta', label: { en: 'Bold sillage', fr: 'Sillage affirmé' } } ] },
    { id: 'season', type: 'single',
      title: { en: 'Your go-to season?', fr: 'Votre saison de prédilection ?' },
      options: [
        { v: 'spring', img: IMG + 'SPRING.png?v=1708645536', label: { en: 'Spring', fr: 'Printemps' } },
        { v: 'summer', img: IMG + 'Summer.png?v=1697892018', label: { en: 'Summer', fr: 'Été' } },
        { v: 'fall',   img: IMG + 'Fall.png?v=1697892018',   label: { en: 'Fall', fr: 'Automne' } },
        { v: 'winter', img: IMG + 'WINTER.png?v=1703507377', label: { en: 'Winter', fr: 'Hiver' } },
        { v: 'all',    icon: 'spark', tint: 'multi',         label: { en: 'All year', fr: 'Toute l’année' } } ] }
  ];

  var ARCHETYPES = {
    fresh: { q: { en: 'fresh', fr: 'frais' },
      name: { en: 'The Fresh Spirit', fr: 'L’Esprit Frais' },
      line: { en: 'Bright, clean & effortless', fr: 'Lumineux, net et sans effort' },
      desc: { en: 'You’re drawn to crisp citrus, sparkling bergamot and that just-out-of-the-shower clarity. Your signature feels light, modern and impossibly easy to wear.',
              fr: 'Vous êtes attiré par les agrumes pétillants, la bergamote éclatante et cette fraîcheur de sortie de douche. Votre signature est légère, moderne et incroyablement facile à porter.' },
      notes: { en: ['Bergamot', 'Blood Orange', 'Sea Air', 'Mint'], fr: ['Bergamote', 'Orange sanguine', 'Air marin', 'Menthe'] } },
    floral: { q: { en: 'floral', fr: 'floral' },
      name: { en: 'The Romantic', fr: 'La Romantique' },
      line: { en: 'Soft, elegant & in bloom', fr: 'Doux, élégant et fleuri' },
      desc: { en: 'Petals, powder and a little glow. You love scents that feel graceful and personal — the kind that linger like a memory on a scarf.',
              fr: 'Des pétales, de la poudre et un soupçon d’éclat. Vous aimez les parfums gracieux et personnels — ceux qui s’attardent comme un souvenir sur une écharpe.' },
      notes: { en: ['Rose', 'Peony', 'Jasmine', 'Iris'], fr: ['Rose', 'Pivoine', 'Jasmin', 'Iris'] } },
    woody: { q: { en: 'woody', fr: 'boisé' },
      name: { en: 'The Warm Woods', fr: 'Les Bois Chaleureux' },
      line: { en: 'Grounded, cozy & confident', fr: 'Ancré, réconfortant et assuré' },
      desc: { en: 'Smooth cedar, creamy sandalwood and a whisper of amber. Your scent is warm, reassuring and quietly magnetic — comfort with an edge.',
              fr: 'Cèdre velouté, santal crémeux et une touche d’ambre. Votre parfum est chaleureux, rassurant et discrètement magnétique — du confort avec du caractère.' },
      notes: { en: ['Cedarwood', 'Sandalwood', 'Amber', 'Vetiver'], fr: ['Cèdre', 'Santal', 'Ambre', 'Vétiver'] } },
    gourmand: { q: { en: 'gourmand', fr: 'gourmand' },
      name: { en: 'The Sweet Indulgence', fr: 'La Gourmandise' },
      line: { en: 'Cozy, edible & addictive', fr: 'Réconfortant, gourmand et addictif' },
      desc: { en: 'Vanilla, caramel and a dusting of cocoa. You like fragrances that feel like a treat — warm, inviting and impossible to stop sniffing.',
              fr: 'Vanille, caramel et un nuage de cacao. Vous aimez les parfums qui ressemblent à une douceur — chaleureux, enveloppants et irrésistibles.' },
      notes: { en: ['Vanilla', 'Caramel', 'Tonka', 'Cocoa'], fr: ['Vanille', 'Caramel', 'Fève tonka', 'Cacao'] } },
    oriental: { q: { en: 'oriental', fr: 'oriental' },
      name: { en: 'The Bold & Spiced', fr: 'L’Audacieux Épicé' },
      line: { en: 'Magnetic, deep & unforgettable', fr: 'Magnétique, profond et inoubliable' },
      desc: { en: 'Cardamom, amber and smoky depth. You wear scent like a statement — rich, confident and the kind people remember long after you’ve left the room.',
              fr: 'Cardamome, ambre et profondeur fumée. Vous portez le parfum comme une affirmation — riche, assuré et de ceux dont on se souvient longtemps après votre départ.' },
      notes: { en: ['Cardamom', 'Amber', 'Oud', 'Saffron'], fr: ['Cardamome', 'Ambre', 'Oud', 'Safran'] } },
    fruity: { q: { en: 'fruity', fr: 'fruité' },
      name: { en: 'The Playful Charmer', fr: 'Le Charmeur Espiègle' },
      line: { en: 'Juicy, fun & flirtatious', fr: 'Juteux, ludique et enjôleur' },
      desc: { en: 'Ripe peach, bright berries and a flirty wink. Your scent is energetic and joyful — the kind that makes people smile before they know why.',
              fr: 'Pêche mûre, baies éclatantes et un clin d’œil coquin. Votre parfum est énergique et joyeux — de ceux qui font sourire avant même qu’on sache pourquoi.' },
      notes: { en: ['Peach', 'Blackcurrant', 'Apple', 'Raspberry'], fr: ['Pêche', 'Cassis', 'Pomme', 'Framboise'] } }
  };

  var FAMILY_TO_ARCH = { fresh: 'fresh', aquatic: 'fresh', green: 'fresh', floral: 'floral', woody: 'woody', gourmand: 'gourmand', oriental: 'oriental', fruity: 'fruity' };
  var FAMILY_FT = {
    fresh:    ['FRESH', 'CITRUS', 'AIRY', 'AQUATIC', 'MARINE', 'SALTY'],
    floral:   ['FLORAL', 'WHITEFLORAL', 'ROSE', 'IRIS', 'POWDERY'],
    woody:    ['WOODY', 'EARTHY', 'CHYPRE'],
    gourmand: ['GOURMAND', 'SWEET', 'VANILLA', 'CARAMEL', 'COFFEE', 'COCONUTY', 'BOOZY'],
    oriental: ['ORIENTAL', 'AMBERY', 'SPICY', 'WARM', 'RESINOUS', 'BALSAMIC', 'AOUD', 'LEATHERY'],
    fruity:   ['FRUITY', 'TROPICAL'],
    aquatic:  ['AQUATIC', 'MARINE', 'SALTY'],
    green:    ['GREEN', 'AROMATIC', 'EARTHY']
  };
  var FAMILY_QUERY = {
    fresh: { en: 'fresh', fr: 'frais' }, floral: { en: 'floral', fr: 'floral' }, woody: { en: 'woody', fr: 'boisé' },
    gourmand: { en: 'gourmand sweet', fr: 'gourmand sucré' }, oriental: { en: 'oriental amber spicy', fr: 'oriental ambré épicé' },
    fruity: { en: 'fruity', fr: 'fruité' }, aquatic: { en: 'aquatic marine', fr: 'aquatique marine' }, green: { en: 'green aromatic', fr: 'vert aromatique' }
  };
  var VIBE_NUDGE = { bold: ['oriental', 'woody'], soft: ['floral', 'gourmand'], fresh: ['fresh'], warm: ['woody', 'gourmand'], mysterious: ['oriental', 'woody'] };
  var SEASON_NUDGE = { summer: ['fresh', 'fruity'], spring: ['floral', 'fresh'], fall: ['woody', 'oriental'], winter: ['oriental', 'gourmand'], all: [] };

  var els = {
    intro: root.querySelector('[data-screen="intro"]'),
    quiz: root.querySelector('[data-screen="quiz"]'),
    result: root.querySelector('[data-screen="result"]'),
    step: root.querySelector('[data-step]'),
    fill: root.querySelector('[data-progress-fill]'),
    plabel: root.querySelector('[data-progress-label]'),
    back: root.querySelector('[data-back]'),
    next: root.querySelector('[data-next]'),
    matches: root.querySelector('[data-sf-matches]'),
    matchesBody: root.querySelector('[data-sf-matches-body]'),
    matchesTitle: root.querySelector('[data-sf-matches-title]'),
    matchesSub: root.querySelector('[data-sf-matches-sub]'),
    matchesAll: root.querySelector('[data-sf-matches-all]'),
    notice: root.querySelector('[data-sf-notice]'),
    noticeClose: root.querySelector('[data-sf-notice-close]'),
    mp: root.querySelector('[data-sf-monthpick]'),
    mpClose: root.querySelector('[data-mp-close]'),
    mpText: root.querySelector('[data-mp-text]'),
    mpLabel: root.querySelector('[data-mp-label]'),
    mpSelect: root.querySelector('[data-mp-select]'),
    mpSur: root.querySelector('[data-mp-sur]'),
    mpEmpty: root.querySelector('[data-mp-empty]'),
    mpSkip: root.querySelector('[data-mp-skip]'),
    mpCancel: root.querySelector('[data-mp-cancel]'),
    mpConfirm: root.querySelector('[data-mp-confirm]'),
    matchesHide: root.querySelector('[data-sf-matches-hide]')
  };

  var answers = {};
  var idx = 0;
  var RESULT_KEY = 'sc_scent_finder_result';

  function show(name) {
    ['intro', 'quiz', 'result'].forEach(function (k) { els[k].hidden = (k !== name); });
  }

  function renderStep() {
    var s = STEPS[idx];
    var chosen = answers[s.id] || (s.type === 'multi' ? [] : null);
    var sub = T(s.sub) ? '<p class="sf-step__sub">' + T(s.sub) + '</p>' : '';
    var html = '<h2 class="sf-step__title">' + T(s.title) + '</h2>' + sub +
      '<div class="sf-options" role="group" aria-label="' + T(s.title) + '">';
    s.options.forEach(function (o) {
      var sel = s.type === 'multi' ? (chosen.indexOf(o.v) !== -1) : (chosen === o.v);
      html += '<button type="button" class="sf-opt" data-v="' + o.v + '" aria-pressed="' + (sel ? 'true' : 'false') + '">' +
        mediaHtml(o, s.id) +
        '<span class="sf-opt__label">' + T(o.label) + '</span>' +
        '<span class="sf-opt__check" aria-hidden="true">' + CHECK + '</span>' +
        '</button>';
    });
    html += '</div>';
    els.step.innerHTML = html;

    els.step.querySelectorAll('.sf-opt').forEach(function (btn) {
      btn.addEventListener('click', function () { choose(s, btn.getAttribute('data-v')); });
    });

    els.fill.style.width = Math.round(idx / STEPS.length * 100) + '%';
    els.plabel.textContent = T(UI.qa) + (idx + 1) + T(UI.qb) + STEPS.length;
    els.back.hidden = idx === 0;
    els.next.textContent = idx === STEPS.length - 1 ? T(UI.see) : T(UI.next);
    syncNext(s);
    var firstSel = els.step.querySelector('.sf-opt[aria-pressed="true"]') || els.step.querySelector('.sf-opt');
    if (firstSel) { try { firstSel.focus(); } catch (e) {} }
  }

  function choose(s, v) {
    var line = els.step.querySelector('.sf-opt[data-v="' + v + '"]');
    if (s.type === 'multi') {
      var arr = answers[s.id] ? answers[s.id].slice() : [];
      var at = arr.indexOf(v);
      if (at !== -1) { arr.splice(at, 1); }
      else { if (arr.length >= (s.max || 99)) return; arr.push(v); }
      answers[s.id] = arr;
      if (line) line.setAttribute('aria-pressed', arr.indexOf(v) !== -1 ? 'true' : 'false');
    } else {
      answers[s.id] = v;
      els.step.querySelectorAll('.sf-opt').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-v') === v ? 'true' : 'false');
      });
    }
    syncNext(s);
  }

  function syncNext(s) {
    var a = answers[s.id];
    els.next.disabled = s.type === 'multi' ? !(a && a.length > 0) : !a;
  }

  function next() {
    if (els.next.disabled) return;
    if (idx < STEPS.length - 1) { idx++; renderStep(); }
    else { showResult(); }
  }
  function back() { if (idx > 0) { idx--; renderStep(); } else { show('intro'); } }

  function computeArchetype() {
    var score = { fresh: 0, floral: 0, woody: 0, gourmand: 0, oriental: 0, fruity: 0 };
    (answers.families || []).forEach(function (f, i) {
      var a = FAMILY_TO_ARCH[f]; if (a) score[a] += (i === 0 ? 3 : 2);
    });
    (VIBE_NUDGE[answers.vibe] || []).forEach(function (a) { score[a] += 1.5; });
    (SEASON_NUDGE[answers.season] || []).forEach(function (a) { score[a] += 1; });
    if (answers.intensity === 'bold') { score.oriental += 0.5; score.woody += 0.5; }
    if (answers.intensity === 'subtle') { score.fresh += 0.5; score.floral += 0.5; }

    var order = ['fresh', 'floral', 'woody', 'gourmand', 'oriental', 'fruity'];
    if (answers.families && answers.families.length) {
      var firstArch = FAMILY_TO_ARCH[answers.families[0]];
      if (firstArch) order = [firstArch].concat(order.filter(function (k) { return k !== firstArch; }));
    }
    var best = order[0], bestVal = -1;
    order.forEach(function (k) { if (score[k] > bestVal) { bestVal = score[k]; best = k; } });
    return ARCHETYPES[best];
  }

  function parseProducts(doc) {
    var cards = doc.querySelectorAll('#search-page .product_block');
    var list = [];
    Array.prototype.forEach.call(cards, function (c) {
      var nameEl = c.querySelector('.product-name');
      var img = c.querySelector('.product_img_link img');
      var href = nameEl ? nameEl.getAttribute('href') : (c.querySelector('a') ? c.querySelector('a').getAttribute('href') : '#');
      list.push({
        url: href || '#',
        title: nameEl ? nameEl.textContent.trim() : '',
        brand: c.getAttribute('data-vendor') || '',
        ft: (c.getAttribute('data-ft') || '').trim().split(/\s+/).filter(Boolean),
        img: img ? img.outerHTML : '',
        pid: c.getAttribute('data-pid') || '',
        handle: c.getAttribute('data-handle') || '',
        exclusive: c.getAttribute('data-exclusive') === '1',
        price: parseFloat(c.getAttribute('data-price')) || 0
      });
    });
    return list;
  }
  function buildCalendar(products) {
    var per = 2;
    var now = new Date();
    var sm = MONTHS_SHORT[LANG] || MONTHS_SHORT.en;
    var months = Math.min(12, Math.ceil(products.length / per));
    function card(prod, label) {
      if (!prod) { return ''; }
      var sur = prod.exclusive ? '<span class="sf-cal__surcharge">' + T(UI.exclusiveTag) + '</span>' : '';
      return '<div class="sf-cal__card" data-pid="' + (prod.pid || '') + '" data-handle="' + (prod.handle || '') + '" data-title="' + escAttr(prod.title) + '" data-brand="' + escAttr(prod.brand) + '" data-surcharge="' + (prod.exclusive ? '5.00' : '') + '">' +
               '<a class="sf-cal__link" href="' + prod.url + '" target="_blank" rel="noopener">' +
               '<span class="sf-cal__media">' + prod.img + '</span>' +
               (prod.brand ? '<span class="sf-cal__brand">' + prod.brand + '</span>' : '') +
               '<span class="sf-cal__name">' + prod.title + '</span>' +
               '<span class="sf-cal__month">' + label + '</span>' +
               '</a>' + sur +
               '<button type="button" class="sf-cal__add" data-cal-add aria-label="' + T(UI.addAria) + '" title="' + T(UI.addAria) + '">+</button>' +
             '</div>';
    }
    function escAttr(s) { return (s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;'); }
    var row1 = '', row2 = '';
    for (var m = 0; m < months; m++) {
      var d = new Date(now.getFullYear(), now.getMonth() + m, 1);
      var label = sm[d.getMonth()] + '-' + d.getFullYear();
      row1 += card(products[m * per], label);
      row2 += card(products[m * per + 1], label);
    }
    var exclusiveCount = 0;
    for (var i = 0; i < products.length; i++) { if (products[i].exclusive) { exclusiveCount++; } }
    var surTotal = exclusiveCount * 5;
    var surLine = exclusiveCount > 0
      ? '<p class="sf-cal__surtotal">' + products.length + ' ' + T(UI.scentsSelected) + ', +C$' + surTotal.toFixed(2) + ' ' + T(UI.surchargeNote) + '</p>'
      : '<p class="sf-cal__surtotal">' + products.length + ' ' + T(UI.scentsSelected) + '</p>';
    return '<div class="sf-cal"><div class="sf-cal__row">' + row1 + '</div><div class="sf-cal__row">' + row2 + '</div></div>' +
           '<div class="sf-cal__addall-wrap">' +
             surLine +
             '<button type="button" class="sf-btn sf-btn--primary sf-btn--lg sf-cal__addall" data-cal-addall>' + T(UI.addAllLabel) + '</button>' +
             '<p class="sf-cal__addall-hint">' + T(UI.addAllHint) + '</p>' +
           '</div>';
  }
  function syncCalendarScroll() {
    var rows = els.matchesBody.querySelectorAll('.sf-cal__row');
    if (rows.length < 2) { return; }
    var lock = false;
    Array.prototype.forEach.call(rows, function (row) {
      row.addEventListener('scroll', function () {
        if (lock) { return; }
        lock = true;
        Array.prototype.forEach.call(rows, function (other) { if (other !== row) { other.scrollLeft = row.scrollLeft; } });
        requestAnimationFrame(function () { lock = false; });
      });
    });
  }
  var GENDER_TERM = { feminine: 'women', masculine: 'men', unisex: '', any: '' };
  function genderOfUrl(url) {
    var h = (url || '').split('?')[0].replace(/\/+$/, '');
    if (/-women$/.test(h)) { return 'W'; }
    if (/-unisex$/.test(h)) { return 'U'; }
    if (/-men$/.test(h)) { return 'M'; }
    return '?';
  }
  function genderAllows(sel, g) {
    if (sel === 'feminine') { return g === 'W' || g === 'U'; }
    if (sel === 'masculine') { return g === 'M' || g === 'U'; }
    return true;
  }
  function familyMatches(famKey, ft) {
    var cluster = FAMILY_FT[famKey];
    if (!cluster) { return true; }
    for (var i = 0; i < ft.length; i++) { if (cluster.indexOf(ft[i]) !== -1) { return true; } }
    return false;
  }
  function showMatches(url, gsel, famKey) {
    if (!els.matches) { return; }
    els.matchesTitle.textContent = T(UI.calTitle);
    if (els.matchesSub) { els.matchesSub.textContent = T(UI.calSub); }
    els.matchesAll.setAttribute('href', url);
    els.matchesAll.textContent = T(UI.viewAll);
    els.matchesAll.hidden = true;
    els.matchesBody.className = 'sf-matches__body is-state';
    els.matchesBody.textContent = T(UI.loading);
    els.matches.hidden = false;
    Promise.all([1, 2, 3, 4, 5].map(function (p) {
      return fetch(url + '&page=' + p).then(function (r) { return r.text(); }).catch(function () { return ''; });
    })).then(function (htmls) {
      var products = [];
      htmls.forEach(function (html) { if (html) { products = products.concat(parseProducts(new DOMParser().parseFromString(html, 'text/html'))); } });
      var genderOk = products.filter(function (pr) { return genderAllows(gsel, genderOfUrl(pr.url)); });
      var picked = genderOk.filter(function (pr) { return familyMatches(famKey, pr.ft); });
      if (picked.length < 12) {
        var seen = {}; picked.forEach(function (p) { seen[p.url] = 1; });
        genderOk.forEach(function (pr) { if (picked.length < 24 && !seen[pr.url]) { picked.push(pr); seen[pr.url] = 1; } });
      }
      var finalProducts = picked.slice(0, 24);
      if (finalProducts.length) {
        els.matchesBody.className = 'sf-matches__body';
        els.matchesBody.innerHTML = buildCalendar(finalProducts);
        syncCalendarScroll();
        els.matchesAll.hidden = false;
      } else {
        els.matchesBody.className = 'sf-matches__body is-state';
        els.matchesBody.textContent = T(UI.empty);
      }
    }).catch(function () {
      els.matchesBody.className = 'sf-matches__body is-state';
      els.matchesBody.textContent = T(UI.empty);
    });
  }
  function hideMatches() {
    if (!els.matches) { return; }
    els.matches.hidden = true;
    els.matchesBody.innerHTML = '';
  }

  /* ---- Quiz "Add to calendar" (+ / Add all 12) ----
     Non-subscribers: stash picks locally, show subscribe/sign-in notice (unchanged).
     Subscribers: fetch real open months via the account page's subCheck() API (loaded
     globally by assets/custom.js) and let the person pick which month, inline, no redirect. */
  var STASH_KEY = 'sf_pending_calendar';
  var TOKEN = root.getAttribute('data-customer-token') || '';
  var MP_MONTHS = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
  var MP_MFULL = { Jan: 'January', Feb: 'February', Mar: 'March', Apr: 'April', May: 'May', Jun: 'June', Jul: 'July', Aug: 'August', Sep: 'September', Oct: 'October', Nov: 'November', Dec: 'December' };
  function mpMonthIdx(m) { if (!m) { return null; } var p = m.split('-'); var mo = MP_MONTHS[p[0]]; var y = parseInt(p[1], 10); if (mo == null || isNaN(y)) { return null; } return y * 12 + mo; }
  function mpNowIdx() { var d = new Date(); return d.getFullYear() * 12 + d.getMonth(); }
  function mpPretty(m) { if (!m) { return m; } var p = m.split('-'); return (MP_MFULL[p[0]] || p[0]) + ' ' + p[1]; }

  function readCardData(card) {
    return {
      pid: card.getAttribute('data-pid') || '',
      handle: card.getAttribute('data-handle') || '',
      title: card.getAttribute('data-title') || '',
      brand: card.getAttribute('data-brand') || '',
      surcharge: parseFloat(card.getAttribute('data-surcharge')) || 0,
      cardEl: card
    };
  }
  function stash(items) {
    try {
      var existing = JSON.parse(localStorage.getItem(STASH_KEY) || '[]');
      var seen = {}; existing.forEach(function (p) { seen[p.pid] = 1; });
      items.forEach(function (p) { if (!seen[p.pid]) { existing.push({ pid: p.pid, handle: p.handle, title: p.title, brand: p.brand, surcharge: p.surcharge }); seen[p.pid] = 1; } });
      localStorage.setItem(STASH_KEY, JSON.stringify(existing));
    } catch (e) {}
  }
  function openNotice() { if (els.notice) { els.notice.hidden = false; } }
  function closeNotice() { if (els.notice) { els.notice.hidden = true; } }
  if (els.noticeClose) { els.noticeClose.addEventListener('click', closeNotice); }
  if (els.notice) { els.notice.addEventListener('click', function (e) { if (e.target === els.notice) { closeNotice(); } }); }

  var openSlotsPromise = null;
  function fetchOpenSlots(force) {
    if (openSlotsPromise && !force) { return openSlotsPromise; }
    openSlotsPromise = (typeof subCheck === 'function' ? subCheck(TOKEN) : Promise.reject(new Error('subCheck unavailable')))
      .then(function (res) {
        var out = [];
        var cur = mpNowIdx();
        (res && res.products || []).forEach(function (group) {
          (group || []).forEach(function (item) {
            if (item && item.product_handle === 'scent-of-the-month') {
              var mi = mpMonthIdx(item.month);
              if (mi != null && mi >= cur) { out.push({ month: item.month, idx: mi, serial: item.id, key: item.key }); }
            }
          });
        });
        out.sort(function (a, b) { return a.idx - b.idx; });
        return out;
      })
      .catch(function () { return []; });
    return openSlotsPromise;
  }
  var mpConsumedSerials = {};
  function availableSlots(slots) {
    return slots.filter(function (s) { return !mpConsumedSerials[s.serial]; });
  }

  var mpBusy = false;
  var mpQueue = [];
  var mpCurrent = null;

  function closeMonthPicker() { if (els.mp) { els.mp.hidden = true; } mpQueue = []; mpCurrent = null; }
  if (els.mpClose) { els.mpClose.addEventListener('click', closeMonthPicker); }
  if (els.mp) { els.mp.addEventListener('click', function (e) { if (e.target === els.mp) { closeMonthPicker(); } }); }
  if (els.mpCancel) { els.mpCancel.addEventListener('click', function () { advanceQueueOrClose(); }); }
  if (els.mpSkip) { els.mpSkip.addEventListener('click', function () { advanceQueueOrClose(); }); }

  function advanceQueueOrClose() {
    if (mpQueue.length) { showMonthPickerFor(mpQueue.shift()); } else { closeMonthPicker(); }
  }

  function showMonthPickerFor(item) {
    mpCurrent = item;
    fetchOpenSlots().then(function (allSlots) {
      var slots = availableSlots(allSlots);
      els.mpText.textContent = (item.brand ? item.brand + ' ' : '') + item.title;
      els.mpLabel.textContent = T(UI.mpLabel);
      els.mpSkip.hidden = mpQueue.length === 0 && !mpQueueRunning;
      els.mpSkip.textContent = T(UI.mpSkip);
      els.mpCancel.textContent = T(UI.mpCancel);
      els.mpConfirm.textContent = T(UI.mpConfirm);
      els.mpConfirm.disabled = false;
      if (!slots.length) {
        els.mpSelect.hidden = true; els.mpLabel.hidden = true;
        els.mpEmpty.hidden = false; els.mpEmpty.textContent = T(UI.mpEmpty);
        els.mpSur.hidden = true;
        els.mpConfirm.hidden = true;
      } else {
        els.mpSelect.hidden = false; els.mpLabel.hidden = false;
        els.mpEmpty.hidden = true;
        els.mpConfirm.hidden = false;
        els.mpSelect.innerHTML = slots.map(function (s) {
          return '<option value="' + s.serial + '">' + mpPretty(s.month) + '</option>';
        }).join('');
        els.mpSur.hidden = !(item.surcharge > 0);
        if (item.surcharge > 0) { els.mpSur.textContent = T(UI.mpSurcharge); }
      }
      els.mp.hidden = false;
    });
  }

  var mpQueueRunning = false;

  function doConfirmAdd() {
    if (mpBusy || !mpCurrent) { return; }
    var serial = els.mpSelect.value;
    if (!serial) { return; }
    mpBusy = true;
    els.mpConfirm.disabled = true;
    els.mpConfirm.textContent = T(UI.mpAdding);
    var data = { id: serial, shopify_product_id: mpCurrent.pid, product_handle: mpCurrent.handle };
    fetch(BASE_URL() + '/api/customer/products/update', {
      method: 'PUT', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + TOKEN }, body: JSON.stringify(data)
    }).then(function (r) { return r.json(); }).then(function () {
      mpConsumedSerials[serial] = true;
      if (mpCurrent.cardEl) {
        mpCurrent.cardEl.classList.add('is-added');
        var b = mpCurrent.cardEl.querySelector('[data-cal-add]');
        if (b) { b.disabled = true; b.textContent = '✓'; b.setAttribute('aria-label', T(UI.addedAria)); }
      }
      mpBusy = false;
      if (mpQueue.length) { showMonthPickerFor(mpQueue.shift()); }
      else { mpQueueRunning = false; closeMonthPicker(); }
    }).catch(function () {
      mpBusy = false;
      els.mpConfirm.disabled = false;
      els.mpConfirm.textContent = T(UI.mpConfirm);
    });
  }
  if (els.mpConfirm) { els.mpConfirm.addEventListener('click', doConfirmAdd); }
  function BASE_URL() { return (typeof baseurl !== 'undefined' && baseurl) ? baseurl : 'http://shopify.scentclub.ca'; }

  els.matchesBody.addEventListener('click', function (e) {
    var addAllBtn = e.target.closest('[data-cal-addall]');
    if (addAllBtn) {
      e.preventDefault();
      if (addAllBtn.disabled) { return; }
      var cards = els.matchesBody.querySelectorAll('.sf-cal__card:not(.is-added)');
      var items = Array.prototype.map.call(cards, readCardData);
      if (!items.length) { return; }
      if (!TOKEN) { stash(items); openNotice(); return; }
      mpQueueRunning = true;
      mpQueue = items.slice(1);
      showMonthPickerFor(items[0]);
      return;
    }
    var addBtn = e.target.closest('[data-cal-add]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.disabled) { return; }
      var card = addBtn.closest('.sf-cal__card');
      if (!card) { return; }
      var item = readCardData(card);
      if (!TOKEN) { stash([item]); openNotice(); return; }
      mpQueueRunning = false;
      mpQueue = [];
      showMonthPickerFor(item);
      return;
    }
  });

  function showResult() {
    var a = computeArchetype();
    els.fill.style.width = '100%';
    var ctaUrl = localizeUrl(root.getAttribute('data-cta-url') || '/pages/subscribe');
    var gsel = answers.gender || 'any';
    var gterm = GENDER_TERM[gsel] || '';
    var famKey = (answers.families && answers.families[0]) || null;
    var famTerm = (famKey && FAMILY_QUERY[famKey]) ? T(FAMILY_QUERY[famKey]) : T(a.q);
    var searchQ = famTerm + (gterm ? ' ' + gterm : '');
    var browseUrl = localizeUrl('/search') + '?q=' + encodeURIComponent(searchQ) + '&type=product';
    var notes = (a.notes[LANG] || a.notes.en).map(function (n) { return '<span class="sf-note">' + n + '</span>'; }).join('');
    els.result.innerHTML =
      '<div class="sf-result__card">' +
        '<span class="sf-result__tag">' + T(UI.tag) + '</span>' +
        '<h2 class="sf-result__name">' + T(a.name) + '</h2>' +
        '<p class="sf-result__line">' + T(a.line) + '</p>' +
        '<p class="sf-result__desc">' + T(a.desc) + '</p>' +
        '<div class="sf-notes">' + notes + '</div>' +
        '<p class="sf-result__meta">' + T(UI.notesCap) + '</p>' +
        '<div class="sf-result__cta">' +
          '<a class="sf-btn sf-btn--primary sf-btn--lg" href="' + ctaUrl + '">' + T(UI.ctaLabel) + '</a>' +
        '</div>' +
        '<button type="button" class="sf-retake" data-retake>' + T(UI.retake) + '</button>' +
      '</div>';
    els.result.querySelector('[data-retake]').addEventListener('click', restart);
    try { sessionStorage.setItem(RESULT_KEY, JSON.stringify(answers)); } catch (e) {}
    show('result');
    showMatches(browseUrl, gsel, famKey);
  }

  function restart() { try { sessionStorage.removeItem(RESULT_KEY); } catch (e) {} answers = {}; idx = 0; els.fill.style.width = '0%'; hideMatches(); show('intro'); }

  root.querySelector('[data-start]').addEventListener('click', function () { idx = 0; show('quiz'); renderStep(); });
  els.next.addEventListener('click', next);
  els.back.addEventListener('click', back);

  if (els.matchesHide) { els.matchesHide.addEventListener('click', hideMatches); }

  try {
    var saved = sessionStorage.getItem(RESULT_KEY);
    if (saved) { var sa = JSON.parse(saved); if (sa && sa.families && sa.families.length) { answers = sa; showResult(); } }
  } catch (e) {}
}
sfInit();
document.addEventListener('shopify:section:load', function (e) {
  if (e.target && e.target.querySelector && e.target.querySelector('[data-scent-finder]')) sfInit();
});
})();
